import { createSelector } from 'reselect';
import { RequestStatus, VIDEO_CUT_OFF_DATE } from '../Constants';
import { Video2OptInStatusTypes } from '../enums/Video2OptInStatusTypes';
import { getUsedEmbeddableVideoCount } from './Limits';

// indicates a job opted-in the portal automatically, or as the default for new portals
const AUTO_OPTIN_USER_ID = 1;
export const getOptInStatus = state => state.video2OptInStatus.getIn(['videoOptInStatus', 'optInStatus']);
export const getOptInUserId = state => state.video2OptInStatus.getIn(['videoOptInStatus', 'userId']);
export const getOptInFetchStatus = state => state.video2OptInStatus.get('fetchVideo2OptInStatusRequestStatus');
export const getOptInUpdateStatus = state => state.video2OptInStatus.get('updateVideo2OptInStatusRequestStatus');
export const getOpenModal = state => {
  return state.video2OptInStatus.get('openModal');
};
export const getPortalHasOptedInOrOut = createSelector([getOptInStatus, getOptInFetchStatus], (optInStatus, fetchStatus) => {
  if (fetchStatus === RequestStatus.SUCCEEDED) {
    return Boolean(optInStatus);
  }
  return null;
});
export const wasPortalOptedInByDefault = createSelector([getOptInStatus, getOptInFetchStatus, getOptInUserId], (optInStatus, fetchStatus, optInUserId) => {
  if (fetchStatus === RequestStatus.SUCCEEDED) {
    return optInStatus === Video2OptInStatusTypes.OPT_IN && optInUserId === AUTO_OPTIN_USER_ID;
  }
  return null;
});
export const getIsVideo2Enabled = createSelector([getOptInStatus], optInStatus => optInStatus === Video2OptInStatusTypes.OPT_IN);
export const shouldShowPickerOptInState = createSelector([getOptInFetchStatus, getIsVideo2Enabled], (fetchStatus, isVideo2Enabled) => {
  if (fetchStatus === RequestStatus.SUCCEEDED) {
    return !isVideo2Enabled;
  }
  return false;
});
export const getIsVideo2AssumedOptedIn = state => {
  const isVideoOptedIn = getIsVideo2Enabled(state);
  const hasPortalOptedInOrOut = getPortalHasOptedInOrOut(state);
  const videoUsageCount = getUsedEmbeddableVideoCount(state);
  return isVideoOptedIn || !hasPortalOptedInOrOut && videoUsageCount > 0 && Date.now() < VIDEO_CUT_OFF_DATE;
};